import * as React from 'react';
import { useMutation } from '@tanstack/react-query';

// API
import { PatchUser } from '../../api';
import { queryClient } from '../../api/queryClient';

// Components
import { LanguageSelectClient } from '../LanguageSelectClient';

//
import { AuthContext } from '../../contexts/Auth';

export const LanguageSelectorRemote: React.FC<{}> = ({}) => {
    const { authState } = React.useContext(AuthContext);
    const patchUser = useMutation(PatchUser, {
        onSuccess: (newData) => {
            queryClient.invalidateQueries({
                queryKey: ['self'],
                exact: true,
                refetchType: 'active'
            });
        },
        onError: (err: any) => {}
    });

    return (
        <LanguageSelectClient
            onChange={(val: string) => {
                if (authState?.userId) {
                    patchUser.mutate({
                        userId: authState?.userId,
                        preferredLang: val
                    });
                }
            }}
        />
    );
};
